module.exports = __webpack_public_path__ + "img/mask.3cd38b7c.png";